import React from "react";
import { Button, Header, Icon, Message, Modal, Segment } from "semantic-ui-react";
import AssetInfo from "../AssetInfo/AssetInfo";
import CampaignInfo from "../CampaignInfo/CampaignInfo";

export const MergeCampaignPreviewModal = ({
  data,
  open,
  setOpen,
  onSuccess,
  onCancel,
  dataForOnSuccess,
  activeUser,
  t,
}) => {
  return (
    <Modal open={open} size="large">
      <Header icon>
        <Icon name={data.icon} />
        {data.headerText}
      </Header>
      <Modal.Content scrolling>
        <h3>{t("merge_campaign_preview")}:</h3>
        <CampaignInfo
          campaign={data.campaign}
          deliveredAssetResolutions={data.deliveredAssetResolutions}
          deliveredImageAssetResolutions={data.deliveredImageAssetResolutions}
          activeUser={activeUser}
          isAdmin={true}
        />

        <h3>{t("pages_assets")}</h3>
        <Segment.Group className="assets-selected-for-merge">
          {data.assets && data.assets.length ? (
            data.assets.map((asset) => (
              <Segment key={asset.id} className="asset-input-item">
                <AssetInfo asset={asset} agencys={data.agencys} users={data.users} t={t} />
              </Segment>
            ))
          ) : (
            <Message>{t("campaign_no_assets_message")}</Message>
          )}
        </Segment.Group>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="red"
          onClick={() => {
            if (onCancel) onCancel();
            setOpen(false);
          }}
        >
          <Icon name="remove" /> {t("cancel")}
        </Button>
        <Button
          color="green"
          onClick={() => {
            onSuccess(dataForOnSuccess);
            setOpen(false);
          }}
        >
          <Icon name="checkmark" /> {t("merge")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
